import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core';
import './css/Select1.css';

const Select1 = (props) => {
    const { title, options, required, error, halfWidth, helperText, value, onChange } = props;

    return (
        <FormControl variant="outlined" className={halfWidth ? 'half-width select-primary-color' : 'full-width select-primary-color'} error={error}>
            <p className="select-title text-left-align m-t-0 m-b-0">{`${title}${required ? '*' : ''}`}</p>
            <Select
                value={value}
                fullWidth
                error={error}
                onChange={onChange}
                required={required}
            >
                {required ? null : (
                    <MenuItem value="">
                        None
                    </MenuItem>
                )}
                {options.map((option) => {
                    return (
                        <MenuItem key={option.value} value={option.value}>
                            {option.title}
                        </MenuItem>
                    );
                })}
            </Select>
            {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
        </FormControl>
    );
};

Select1.propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    required: PropTypes.bool,
    error: PropTypes.bool,
    halfWidth: PropTypes.bool,
    helperText: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

Select1.defaultProps = {
    required: false,
    error: false,
    halfWidth: false,
    helperText: '',
};

export default memo(Select1);
